const ONETRUST_COOKIE_GROUP = {
  NECESSARY: '1',
  PERFORMANCE: '2',
  FUNCTIONAL: '3',
  TARGETING: '4',
} as const;

function parseOtConsentGroups(consent: string) {
  if (!consent) return [];

  const groups = consent
    .split('&')
    .find((s) => s.startsWith('groups='))
    ?.split('=')[1]
    ?.split(',')
    .map((g) => {
      const [id, status] = g.split(':');
      return { id, enabled: status === '1' };
    });

  return groups ?? [];
}

export const OT_CONSENT_COOKIE_NAME = 'OptanonConsent';

function isOtGroupEnabled(
  consent: string,
  groupId: (typeof ONETRUST_COOKIE_GROUP)[keyof typeof ONETRUST_COOKIE_GROUP],
) {
  const groups = parseOtConsentGroups(consent);
  return groups.find((g) => g.id === groupId)?.enabled ?? false;
}

export function isOtFcEnabled(consent: string) {
  return isOtGroupEnabled(consent, ONETRUST_COOKIE_GROUP.FUNCTIONAL);
}

export function isOtPerfEnabled(consent: string) {
  return isOtGroupEnabled(consent, ONETRUST_COOKIE_GROUP.PERFORMANCE);
}
